import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../contexts/ApiProvider";
import { useCmsPage } from "../cms/useCmsContent";
import { defaultDocuments } from "../cms/defaultContent";

function documentHref(document) {
  if (document.href) return document.href;
  if (document.file?.name) {
    return `${process.env.REACT_APP_BACKEND_URL}/file/${document.file.name}`;
  }
  return "#";
}

export default function DocumentsPage() {
  const api = useApi();
  const { content } = useCmsPage("documents");
  const sections = content.sections || {};
  const blocks = content.blocks || [];
  const headerBlock = blocks.find((b) => b.type === "page-header");
  const ctaBlock = blocks.find((b) => b.type === "cta-banner");
  const hero = headerBlock || sections.hero || {};
  const cta = ctaBlock || sections.cta || {};
  const [documents, setDocuments] = useState(defaultDocuments);

  useEffect(() => {
    (async () => {
      const response = await api.get("/api/cms/documents");
      if (response.success && response.documents?.length) {
        setDocuments(response.documents);
      } else {
        setDocuments(defaultDocuments);
      }
    })();
  }, [api]);

  return (
    <div>
      <section className="py-7 py-lg-10 bg-light">
        <div className="container">
          <div className="col-12 col-lg-8">
            <p className="section-kicker mb-3">
              {hero.kicker || "Documents & agréments"}
            </p>
            <h1 className="section-heading mb-4">
              {hero.title || "Des documents publics pour vérifier notre sérieux."}
            </h1>
            <p className="lead text-muted mb-0">
              {hero.description ||
                "Retrouvez les habilitations et références utiles avant de lancer une discussion avec notre équipe."}
            </p>
          </div>
        </div>
      </section>

      <section className="container py-7">
        <div className="row g-4">
          {documents.map((document) => (
            <div className="col-12 col-md-6 col-xl-4" key={document._id || document.href}>
              <article className="document-card h-100">
                <span className="document-badge">{document.type || "PDF"}</span>
                <h2 className="h4 fw-bold mt-4 mb-3">{document.title}</h2>
                <p className="text-muted mb-4">{document.description}</p>
                <a
                  className="btn btn-outline-dark"
                  href={documentHref(document)}
                  target="_blank"
                  rel="noreferrer"
                >
                  Ouvrir le document
                </a>
              </article>
            </div>
          ))}
        </div>

        <div className="content-panel p-4 p-lg-5 mt-6 d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-4">
          <div>
            <p className="section-kicker mb-2">
              {cta.kicker || "Besoin d'un autre document ?"}
            </p>
            <h2 className="h3 fw-bold mb-0">
              {cta.title ||
                "Notre équipe peut vous orienter vers le bon interlocuteur."}
            </h2>
          </div>
          <Link to="/contact" className="btn btn-success">
            {cta.button || "Qualifier ma demande"}
          </Link>
        </div>
      </section>
    </div>
  );
}
